export const PRIVACY_DATA = {
  lastUpdated: "19 February 2026",
  intro: 'At Asterisk Computer (FE) Pte. Ltd. and Asterisk Business Systems Sdn Bhd ("Asterisk", "we", "us", or "our"), we are committed to protecting your personal data. This Privacy Notice explains how we collect, use, disclose and safeguard your personal data in accordance with the Singapore Personal Data Protection Act (PDPA) and applicable data protection laws.',
  sections: [
    {
      title: "Who We Are",
      paragraphs: [
        "Asterisk is a regional digital transformation partner headquartered in Singapore with operations in Malaysia and across Asia Pacific. We help small and medium enterprises modernise and grow through:",
      ],
      bullets: [
        "ERP & CRM solutions",
        "Patient Accounting & Billing systems",
        "Data Science & Analytics (including Microsoft Fabric)",
        "AI and Intelligent Automation",
        "ESG & Sustainability enablement",
        "Digital transformation consulting and managed services",
      ],
      closing: "Because we work at the heart of our customers' finance, operations and data systems, responsible data stewardship is fundamental to how we operate.",
    },
    {
      title: "What Personal Data We Collect",
      paragraphs: ["Depending on your interaction with us, we may collect:"],
      subsections: [
        { heading: "Business Contact Information", items: ["Name", "Company and designation", "Business address", "Email address", "Telephone number"] },
        { heading: "Account & System Information", items: ["User IDs and access credentials", "System logs and usage data", "Transaction records within implemented systems"] },
        { heading: "Billing Information", items: ["Invoicing and payment details"] },
        { heading: "Recruitment Information (if applicable)", items: ["Resume / CV", "Employment history and qualifications"] },
      ],
      closing: "We only collect personal data that is necessary for legitimate business and service purposes.",
    },
    {
      title: "How We Use Your Personal Data",
      paragraphs: ["We use your personal data to:"],
      subsections: [
        { heading: "Deliver Our Services", items: ["Implement, configure and support ERP, CRM, Patient Accounting, Data and ESG solutions", "Manage user access and system administration", "Provide technical support and managed services"] },
        { heading: "Manage Business Relationships", items: ["Respond to enquiries and proposals", "Administer contracts and projects", "Process billing and payments"] },
        { heading: "Improve and Secure Our Solutions", items: ["Monitor system performance and security", "Prevent fraud and misuse", "Improve service quality and customer experience"] },
        { heading: "Meet Legal and Regulatory Obligations", items: ["Comply with applicable laws and industry standards", "Respond to lawful requests from authorities"] },
      ],
      closing: "Where required, we will obtain your consent before using your personal data for marketing communications.",
    },
    {
      title: "Who We May Share Your Data With",
      paragraphs: ["We may share personal data with:"],
      bullets: [
        "Technology partners (e.g., cloud providers such as Microsoft)",
        "Professional advisers (legal, audit, tax)",
        "Subcontractors and implementation partners",
        "Regulators or authorities where required by law",
      ],
      closing: "All third parties are required to protect your data appropriately.",
    },
    {
      title: "Data Security",
      paragraphs: ["We implement appropriate technical and organisational measures, including:"],
      bullets: [
        "Role-based access controls",
        "Multi-factor authentication (MFA)",
        "Encryption of data in transit and at rest",
        "Secure cloud infrastructure (e.g., Microsoft 365, Azure)",
        "Regular security patching and monitoring",
      ],
      closing: "While no system is completely immune to risk, we continuously strengthen our safeguards to protect the data entrusted to us.",
    },
    {
      title: "International Data Transfers",
      paragraphs: [
        "As a regional business using global cloud platforms, your personal data may be processed or stored outside Singapore. Where this occurs, we ensure that appropriate safeguards are in place to provide a level of protection comparable to that required under the PDPA.",
      ],
    },
    {
      title: "Data Retention",
      paragraphs: [
        "We retain personal data only for as long as necessary to fulfil the purposes for which it was collected, or as required by law. When no longer required, data is securely deleted or anonymised.",
      ],
    },
    {
      title: "Your Rights",
      paragraphs: ["You may:"],
      bullets: [
        "Request access to your personal data",
        "Request correction of inaccurate data",
        "Withdraw consent (where applicable)",
      ],
      closing: "To do so, please contact our Data Protection Officer.",
    },
    {
      title: "Contact Us",
      paragraphs: ["Data Protection Officer"],
      contact: {
        company: "Asterisk Computer (FE) Pte. Ltd.",
        tel: "+65 6744 5527",
        email: "dpo@asterisk.com.sg",
      },
    },
    {
      title: "Updates to This Notice",
      paragraphs: [
        "We may update this Privacy Notice from time to time. The latest version will always be published on our website.",
      ],
    },
  ],
};
